import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { routing } from './app.routing';
import { AppComponent } from './components';
import { directives } from './directives';
import { services } from './services';

import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import { SharedModule } from './shared/shared.module';
import { ForgotPasswordDialogComponent } from './login/forgot-password/forgot-password-dialog.component';
import { PreloadAllModulesWithDelay } from './preload';
import { CoreModule } from './core/core.module';


registerLocaleData(localeNl);

@NgModule({
    declarations: [
        directives,
        AppComponent,
    ],
    bootstrap: [AppComponent],
    entryComponents: [ForgotPasswordDialogComponent],
    providers: [
        { provide: LOCALE_ID, useValue: "nl-NL" },
        services,
        PreloadAllModulesWithDelay
    ],
    imports: [
        BrowserAnimationsModule,
        CoreModule,
        SharedModule,
        routing,
    ],
    exports: [

    ]
})
export class AppModule { }
